import React, { Component } from 'react'
import { observer } from 'mobx-react'
import { browserHistory } from 'react-router'
import {
    Button,
    Row
} from 'react-bootstrap'
import { injectStripe, CardElement } from 'react-stripe-elements';


@observer(['invoices', 'quickbooks', 'companies'])
class NewCardForm extends Component {

    constructor(props) {
        super(props)
    }

    handleSubmit(ev) {
        this.props.setLoadableState(true)

        // We don't want to let default form submission happen here, which would refresh the page.
        ev.preventDefault();

        // Within the context of `Elements`, this call to createToken knows which Element to
        // tokenize, since there's only one in this group.
        this.props.stripe.createToken().then(({ token }) => {
            console.log('Received Stripe token:', token);

            if (token && token.id) {
                //We need to remove the "." form the total dollar amount for Stripe.
                var total = this.props.invoices.invoiceDetail.oneTimeTotal.replace('.','');

                const params = {
                    organizationId: this.props.invoices.invoiceDetail.organizationId,
                    invoiceToken: this.props.invoiceToken,
                    stripeCustomerId: this.props.invoices.invoiceDetail.stripeCustomerId,
                    stripeToken: token.id,
                    total: total,
                    email: this.props.invoices.invoiceDetail.defaultContactEmail
                }

                this.props.quickbooks.processNewCustomerPayment(params, (data) => {
                    if (!data || !data.quickbooksNewBillPayment) {
                        alert('We were unable to process your payment. Please try again or contact GPS Leaders.')
                        this.props.setLoadableState(false)
                        return
                    }
                    if (data.quickbooksNewBillPayment.statusCode == 200) {
                        browserHistory.push('/paymentconfirmation')
                        //alert(data.quickbooksBillPayment.data.message)
                    }
                    else {
                        alert(data.quickbooksNewBillPayment.data.message)
                        this.props.setLoadableState(false)
                    }
                })
            } else {
                console
                alert('Please check your card information.')
                this.props.setLoadableState(false)
            }            
        }).catch((err) => {
            console.log('Error: ', err)
            alert('We were unable to process your card. Please try again or contact GPS Leaders.')
            this.props.setLoadableState(false)
        })
    }

    render() {

        var paymentPanel = (
            <form onSubmit={this.handleSubmit.bind(this)}>
                <div className="form-row">
                    <label htmlFor="card-element"></label>
                        <CardElement style={{ base: { fontSize: '18px' } }} />
                    <div id="card-errors" role="alert"></div>
                </div>
                <Button onClick={ this.handleSubmit.bind(this) } bsStyle="success">Submit Payment</Button>
            </form>
        )

        return (
            <div>
                { paymentPanel }
            </div>
        )
    }
}

export default injectStripe(NewCardForm);


// WEBPACK FOOTER //
// ./src/components/invoices/newcardform.js